import { render, staticRenderFns } from "./copyDaHuoV4.vue?vue&type=template&id=11ced0e4&scoped=true&"
import script from "./copyDaHuoV4.vue?vue&type=script&lang=js&"
export * from "./copyDaHuoV4.vue?vue&type=script&lang=js&"
import style0 from "./copyDaHuoV4.vue?vue&type=style&index=0&id=11ced0e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ced0e4",
  null
  
)

export default component.exports